import { DropdownsValues } from '../Dropdowns/const.dropdowns';
import { PersonType } from '../Models/const.personType';

export module DocumentsNeedNotifications{
  export class PrestacoesMorte  {

    //Para este DOC, o user têm que ter escolhido:
    //-Qualificação do remetente: "Representante legal"
    public static RepresentacaoLegal: models.DocumentosObservableVM = {
      stepCode: "StepSender",
      cardCode: "SenderQualification",
      fieldCode: "isLegalRepresentative",
      documentTipologyCode: DropdownsValues.dropListDocuments.ComprovativoRepresLegal,
      documentTipologyDescription: "Comprovativo de Representação Legal",
      path: "StepSender/SenderQualification/isLegalRepresentative",
      beneficiaryID: PersonType.Sender
    };


    //Para este DOC, o user têm que ter escolhido:
    //-Beneficiario: "Tem Representantação legal"
    public static RepresentacaoLegalBeneficiary: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "hasLegalRepresentation",
      documentTipologyCode: DropdownsValues.dropListDocuments.ComprovativoRepresLegal,
      documentTipologyDescription: "Comprovativo de Representação Legal",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/hasLegalRepresentation",
      beneficiaryID: PersonType.Beneficiary
    };


    //Para este DOC, o user têm que ter escolhido:
    //-Beneficiario: "Tem Representantação legal"
    public static RepresentacaoLegalCertidaoBeneficiary: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "hasLegalRepresentation",
      documentTipologyCode: DropdownsValues.dropListDocuments.CertidaoNascReprLegal,
      documentTipologyDescription: "Certidão Nascimento Representante Legal",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/hasLegalRepresentation",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Nome: Estar preenchido
    public static CertidaoNascimentoFalecido: models.DocumentosObservableVM = {
      stepCode: "StepDeceased",
      cardCode: "DeceasedIdentification",
      fieldCode: "name",
      documentTipologyCode: DropdownsValues.dropListDocuments.CertidaoNascFalecido,
      documentTipologyDescription: "Certidão Nascimento Falecido",
      path: "StepDeceased/DeceasedIdentification/name",
      beneficiaryID: PersonType.Deceased
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Estava a receber uma pensão de aposentação/reforma pela CGA à data do óbito?: "Não" ||
    //-Último serviço onde exerceu funções: Estar preenchido
    public static ProvaEfectividade: models.DocumentosObservableVM = {
      stepCode: "StepDeceased",
      cardCode: "ProfessionalCategory",
      fieldCode: "hadPensionCGABeforeDeath",
      documentTipologyCode: DropdownsValues.dropListDocuments.ProvaEfetividade,
      documentTipologyDescription: "Prova de Efetividade",
      path: "StepDeceased/ProfessionalCategory/hadPensionCGABeforeDeath",
      beneficiaryID: PersonType.Deceased
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Reembolso de despesas de funeral"
    public static FaturaOuRecibo: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "reimbursementFuneralBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.FaturaOuRecibo,
      documentTipologyDescription: "Original da Fatura e do recibo da despesa de funeral",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/reimbursementFuneralBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: Estar preenchida
    public static CertidaoNascimentoRequerente: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.CertidaoNascRequerente,
      documentTipologyDescription: "Certidão Nascimento Requerente",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "União de Facto"
    public static AtestadoJuntaFreguesia: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "reimbursementFuneralBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.AtestadoJuntaFreguesia,
      documentTipologyDescription: "Atestado da Junta de Freguesia",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/reimbursementFuneralBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "União de Facto"
    public static DeclaracaoCompromissoHonra: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.DeclarComprHonra,
      documentTipologyDescription: "Declaração de Compromisso de Honra",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "Filho maior" ||
    //-Relação com o falecido: "Netos maiores" + Encontra-se a cargo do falecido?: "Sim" ||
    //-Ano de matrícula: Data de falecimento ocorra na vigência do ano letivo (Ano de matrícula)
    public static ProvaEscolar: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "relationshipWithDeceased",
      documentTipologyCode: DropdownsValues.dropListDocuments.ProvaEscolar,
      documentTipologyDescription: "Prova Escolar",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/relationshipWithDeceased",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "Filho maior" ||
    //-Relação com o falecido: "Netos maiores" + Encontra-se a cargo do falecido?: "Sim" ||
    //-Sofre de incapacidade permanete e total para o trabalho?: "Sim" ||
    //-Situação profissional ativa?: "Sim"
    public static DocComprovSegurancaSocial: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "relationshipWithDeceased",
      documentTipologyCode: DropdownsValues.dropListDocuments.DocComprovativoSegSocial,
      documentTipologyDescription: "Comprovativo da Segurança Social",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/relationshipWithDeceased",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "Filho maior incapaz" ||
    //-Beneficio requerido: "Pensão de sobrevivência" + Relação com o falecido: "Ex-cônjuge" ||
    //-Existe interdição judicial/acompanhamento de maior?: "Sim" 
    public static Sentenca: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "relationshipWithDeceased",
      documentTipologyCode: DropdownsValues.dropListDocuments.SentencaHabilJudicial,
      documentTipologyDescription: "Sentença",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/relationshipWithDeceased",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Subsidio por morte"/"Pensão de sobrevivência" + Relação com o falecido: "Pais"
    public static DeclaracaoIRS: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.DeclarIRS,
      documentTipologyDescription:  "Declaração de IRS",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Beneficio requerido: "Pensão de sobrevivência" + Relação com o falecido: "Ex-cônjuge" ||
    //-Recebe pensão de alimentos homologada judicialmente?: "Sim"
    public static DeclaracaoPensaoAlimentos: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.DeclarPensaoAlimentos,
      documentTipologyDescription: "Declaração de pensão de alimentos",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Relação com o falecido: "Filho maior incapaz" ||
    //-Relação com o falecido: "Netos menores" + Encontra-se a cargo do falecido?: "Sim" 
    public static DocPrestacoesFamiliares: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "relationshipWithDeceased",
      documentTipologyCode: DropdownsValues.dropListDocuments.DocPrestacoesFamiliares,
      documentTipologyDescription: "Documento de prestações familiares",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/relationshipWithDeceased",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-É beneficiário da pensão de inclusão?: "Sim"
    public static DOCPSI: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.DeclarPrestSocialInclusao,
      documentTipologyDescription: "Documento da pensão social para a inclusão",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-É beneficiário da pensão de inclusão?: "Sim"
    public static CertidaoIsensaoIRS: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "hasSocialPension",
      documentTipologyCode: DropdownsValues.dropListDocuments.CertidaoIsencaoIRS, // VEr com Sisto
      documentTipologyDescription: "Certidão Isenção de IRS",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/hasSocialPension",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, o user têm que ter escolhido:
    //-Conta bancária: Preenchido
    public static ComprovativoIBAN: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "survivalPensionBenefit",
      documentTipologyCode: DropdownsValues.dropListDocuments.ComprovativoIBAN,
      documentTipologyDescription: "Comprovativo de IBAN",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/survivalPensionBenefit",
      beneficiaryID: PersonType.Beneficiary
    };

    //Para este DOC, tem de ser user funerary:
    //-Um por habilitando
    public static RequerendoEmNomeHabilitando: models.DocumentosObservableVM = {
      stepCode: "StepBeneficiary",
      cardCode: "Beneficiary",
      fieldCode: "funerarySenderBeneficiary",
      documentTipologyCode: DropdownsValues.dropListDocuments.DeclRequerHabilitando,
      documentTipologyDescription: "Declaração - Requerente em nome do habilitando",
      path: "StepBeneficiary/BeneficiaryList/Beneficiary/beneficiaryID",
      beneficiaryID: PersonType.Beneficiary
    };









  }
}
